import React, { useCallback, useEffect, useState } from 'react';
import dryftService from '../services/dryftService';

// Dryft Phase 3 — read-only "Recent config changes" list. Shows differences the daily snapshot job
// detected (v2_dryft_change): date, hotel, sub-area → check, change type and the specific item.

const TYPE_STYLE = {
    added:    { label: 'added',    bg: '#ecfdf5', fg: '#047857' },
    removed:  { label: 'removed',  bg: '#fef2f2', fg: '#b91c1c' },
    modified: { label: 'modified', bg: '#eff6ff', fg: '#1d4ed8' },
};

const fmtWhen = (ts) => {
    if (!ts) return '';
    const d = new Date(ts);
    if (isNaN(d.getTime())) return String(ts);
    return d.toLocaleString();
};

const DryftChangesPanel = ({ dryftId }) => {
    const [changes, setChanges] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await dryftService.getChanges(dryftId, 100);
            setChanges(res.data?.changes || []);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to load changes');
        } finally {
            setLoading(false);
        }
    }, [dryftId]);

    useEffect(() => { load(); }, [load]);

    return (
        <div className="pi-list-panel" style={{ marginTop: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px 4px' }}>
                <span style={{ fontWeight: 600, fontSize: 14, color: '#374151' }}>Recent config changes</span>
                <button className="occ-link-btn" onClick={load} disabled={loading}>Refresh</button>
            </div>

            {loading ? (
                <div className="pi-empty"><p className="pi-empty-text">Loading…</p></div>
            ) : error ? (
                <div className="ppw-error-msg" style={{ margin: '8px 16px' }}>{error}</div>
            ) : changes.length === 0 ? (
                <div className="pi-empty">
                    <p className="pi-empty-title">No changes detected yet</p>
                    <p className="pi-empty-text">The daily snapshot job records added, removed and modified config items for the sub-areas this project listens to.</p>
                </div>
            ) : (
                <div className="pi-list">
                    {changes.map((c) => {
                        const st = TYPE_STYLE[c.change_type] || { label: c.change_type, bg: '#f3f4f6', fg: '#374151' };
                        return (
                            <div key={c.id} className="pi-list-item">
                                <div className="pi-item-main">
                                    <div className="pi-item-name">
                                        <span style={{
                                            display: 'inline-block', padding: '1px 8px', borderRadius: 10, marginRight: 8,
                                            fontSize: 11, fontWeight: 600, background: st.bg, color: st.fg,
                                        }}>{st.label}</span>
                                        {c.item_key || '(item)'}
                                    </div>
                                    <div className="pi-item-sub">
                                        {c.hotel_name} · {c.subarea_label} → {c.check_title}
                                    </div>
                                </div>
                                <div className="pi-item-sub" style={{ whiteSpace: 'nowrap', color: '#9ca3af' }}>{fmtWhen(c.detected_at)}</div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default DryftChangesPanel;
